<script>
    import { fade } from 'svelte/transition';
    import { scale } from 'svelte/transition';
    import UserStore from '../stores/user';
    import fetchData from '../api.js';
    import { push , link , replace} from 'svelte-spa-router'
    import { _ } from 'svelte-i18n';

    let email;
    let password;
    let name;
    let error = '';

    localStorage.setItem('user','{}')

    const handleSubmit = async () => {

        let formData = {
            email : email,
            password : password,
            action : 'login',
        }       

        const data = await fetchData(formData);
        if (data.success==1) {

            localStorage.setItem('stores','[]');

            let user = data;

            user.name = name;

            localStorage.setItem('user',JSON.stringify(user))

            UserStore.update(currentUser => {
                return user;
            });

            push('/');

        } else {
            error = $_('login.error');
        }


    }

</script>
<style>

.error {
    color: white;
    font-size:13px;
    background-color: red;
    border-radius:10px;
    padding:5px 10px;
    margin:10px 0 0;
}
.mobile {
  margin-top: 80px;;
}

.desktop {
    display: none;
}

@media (min-width:699px) {   
  

  .mobile {
    display:none;
    margin-top: 0px;
  }

  .desktop {
    display: block;
    margin-top: 0px;
  }


  .login-grid {
    display: flex;
    flex-direction: row-reverse;
    margin: auto;;
    margin-top: 80px;
    max-width: 1200px;
    width: 100%;
    
  }
  
  .login-grid-con {

    flex:1;

  }
  .login-grid-con img {
    width:100%;
  }
  .login-grid-con-pad {
    padding:100px;
    padding-bottom: 0;
  }
  .login-title {
      font-size: 30px;
  }

  
}

</style>
<div class="page login-page" transition:fade={{ delay: 250, duration: 300 }}>

  
    <div class="login-grid">


      <div class="login-grid-con">
        <div class="login-grid-con-pad">
      
          <h1 class="login-title">{$_('login.welcome')}</h1>
        
          <form id="login-form" class="login-form" on:submit|preventDefault={handleSubmit}>
            <input type="text" placeholder="{$_('login.name')}" required bind:value={name}>
            <input type="text" placeholder="{$_('login.email')}" required bind:value={email}>
            <input type="password" placeholder="{$_('login.password')}" required bind:value={password}>
            <div class:error={error!==''} in:scale>{error}</div>
            <button type="submit" class="login-button">{$_('login.login')}</button>
          </form>
        
        </div>

      </div>

    </div>

  </div>